<template>
  <div>
    <v-dialog v-model="dialog" width="900">
      <template v-slot:activator="{ on }">
        <v-btn
          dark
          fab
          bottom
          left
          relative
          color="pink"
          v-on="on"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Add New {{ newWhat }}
        </v-card-title>

        <v-stepper v-model="stepper">
          <v-stepper-header>
            <span v-if="newApp">
              <v-stepper-step :complete="stepper > getStepNum(1)" :step="getStepNum(1)" editable>
                Add Application
              </v-stepper-step>

              <v-divider></v-divider>
            </span>

            <v-stepper-step :complete="stepper > getStepNum(2)" :step="getStepNum(2)" editable>
              Define SLO
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > getStepNum(3)" :step="getStepNum(3)" editable>
              Define SLIs (Data Sources)
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stepper > getStepNum(4)" :step="getStepNum(4)" editable>
              Configure Alerts
            </v-stepper-step>

            <v-divider></v-divider>
          </v-stepper-header>

          <v-form 
            ref="form"
            v-model="valid"
            lazy-validation
          >

            <v-card-text class="grey lighten-2">

            <v-stepper-content v-if="newApp" :step="getStepNum(1)">
              <v-card v-if="newApp">
                <v-container>
                  <v-text-field
                    v-model="newAppName"
                    label="Application Name"
                  ></v-text-field>
                </v-container>
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="getStepNum(2)">
              <v-card>
                <v-container>
                  <div class="subheading">Name</div>
                  <v-text-field
                    v-model="sloName"
                    label="SLO Name"
                    required
                  ></v-text-field>

                  <div class="subheading">Minimum Service Level (Successful / Total)</div>
                  <v-text-field
                    v-model="sloMin"
                    label="Percentage"
                    required
                  ></v-text-field>

                  <div class="subheading">Time Period</div>
                  <v-layout row wrap>
                    <v-flex xs12 pa-2>
                      <v-slider
                        v-model="sloPeriodDays"
                        label="Days"
                        min="0"
                        :max="90"
                        required
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            v-model="sloPeriodDays"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            min="0"
                            max="90"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-flex>
                  </v-layout>
          
                  <v-layout row wrap>
                    <v-flex xs12 pa-2>
                      <v-slider
                        v-model="sloPeriodHours"
                        label="Hours"
                        min="0"
                        :max="23"
                        required
                      >
                        <template v-slot:prepend>
                          <v-text-field
                            v-model="sloPeriodHours"
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            min="0"
                            max="23"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="getStepNum(3)">
              <v-card>
                <v-container>
                  <div class="subheading"># Successful Requests</div>
                  <v-layout row wrap>
                    <v-flex xs12 md4 pa-2>
                      <v-text-field
                        v-model="srServer"
                        label="Prometheus Server"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md8 pa-2>
                      <v-text-field
                        v-model="srQuery"
                        label="PromQL Query"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  
                  <div class="subheading"># Total Requests</div>
                  <v-layout row wrap>
                    <v-flex xs12 md4 pa-2>
                      <v-text-field
                        v-model="trServer"
                        label="Prometheus Server"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md8 pa-2>
                      <v-text-field
                        v-model="trQuery"
                        label="PromQL Query"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="getStepNum(4)">
              <NewBurnRateTriggers :triggers="triggers" />
            </v-stepper-content>
            
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary"
                flat
                @click="submit()"
              >
                Create
              </v-btn>
            </v-card-actions>
          </v-form>

        </v-stepper>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbarSuccess"
      color="success"
      :bottom="true"
      :timeout="5000"
    >
      Created
      <v-btn
        flat
        dark
        @click="snackbarSuccess = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="snackbarError"
      color="error"
      :bottom="true"
      :timeout="5000"
      :muli-line="true"
    >
      {{ error }}
      <v-btn
        flat
        dark
        @click="snackbarError = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import NewBurnRateTriggers from "@/components/NewBurnRateTriggers";

import gql from "graphql-tag";

export default {
  name: "newAppSLO",
  components: {
    NewBurnRateTriggers
  },
  props: {
    newApp: {
      type: Boolean,
      required: true
    },
    appName: {
      type: String
    }
  },
  data() {
    return {
      dialog: false,
      valid: true,
      newAppName: "",
      sloName: "",
      sloMin: 99.9,
      sloPeriodDays: 30,
      sloPeriodHours: 0,
      srServer: "",
      srQuery: "",
      trServer: "",
      trQuery: "",
      snackbarSuccess: false,
      snackbarError: false,
      error: null,
      stepper: 0,
      triggers: [
        {
          burnPct: 2.0,
          burnWindowDays: 0.0,
          burnWindowHours: 1.0
        },
        {
          burnPct: 5.0,
          burnWindowDays: 0.0,
          burnWindowHours: 6.0
        },
        {
          burnPct: 10.0,
          burnWindowDays: 5.0,
          burnWindowHours: 0.0
        },
      ]
    };
  },
  computed: {
    newWhat() {
      return this.newApp ? "Application" : "SLO";
    }
  },
  methods: {
    getStepNum(num) {
      return this.newApp ? num : num - 1;
    },
    submit() {
      var newAppMutation = {
        mutation: gql`mutation addApp($n: NewApp!) {
          addApp(app: $n)
        }`,
        variables: {
          n: {
            name: this.newAppName,
            rateSLO: {
              name: this.sloName,
              appName: this.sloName,
              minPercent: this.sloMin,
              intervalHours: this.sloPeriodDays * 24 + this.sloPeriodHours,
              successSource: {
                sourceURL: this.srServer,
                query: this.srQuery
              },
              totalSource: {
                sourceURL: this.trServer,
                query: this.trQuery
              },
              triggers: this.triggers.map((t) => {
                return {
                  sloID: 0,
                  timeWindowHours: t.burnWindowDays * 24 + t.burnWindowHours,
                  burnPercent: t.burnPct,
                  severity: "page"
                };
              })
            }
          }
        }
      };

      var newSLOMutation = {
        mutation: gql`mutation addRateSLO($n: NewRateSLO!) {
          addRateSLO(slo: $n)
        }`,
        variables: {
          n: {
            name: this.sloName,
            appName: this.appName,
            minPercent: this.sloMin,
            intervalHours: this.sloPeriodDays * 24 + this.sloPeriodHours,
            successSource: {
              sourceURL: this.srServer,
              query: this.srQuery
            },
            totalSource: {
              sourceURL: this.trServer,
              query: this.trQuery
            },
            triggers: this.triggers.map((t) => {
              return {
                sloID: 0,
                timeWindowHours: t.burnWindowDays * 24 + t.burnWindowHours,
                burnPercent: t.burnPct,
                severity: "page"
              };
            })
          }
        }
      };

      var mutation = newSLOMutation;
      if (this.newApp) {
        mutation = newAppMutation;
      }

      this.$apollo.mutate(mutation).then(() => {
        this.snackbarSuccess = true;
        this.clear();
      }).catch(err => {
        this.error = err;
        this.snackbarError = true;
        console.log(err);
        this.clear();
      });
    },
    clear() {
      this.dialog = false;
      this.newAppName = "";
      this.sloName = "";
      this.sloMin = 99.9;
      this.sloPeriodDays = 30;
      this.sloPeriodHours = 0;
      this.srServer = "";
      this.srQuery = "";
      this.trServer = "";
      this.trQuery = "";
    }
  }
};
</script>
